import { match } from "@formatjs/intl-localematcher";
import type { ClientConfigShape } from "@repo/design-system/setup/create-client-config";
import Negotiator from "negotiator";
import type { NextRequest } from "next/server";

/**
 * Return a valid locale for the client. The match function throws an error if it receives invalid values. Hence the try/catch
 * and defaultLocale return
 * @param requestHeaders
 * @param clientConfig
 * @returns
 */
export function handleLocaleHeader(
  requestHeaders: NextRequest["headers"],
  clientConfig: ClientConfigShape[string]
) {
  const { locales, defaultLocale } = clientConfig;
  const headers = Object.fromEntries(requestHeaders);
  const languages = new Negotiator({ headers }).languages();

  return matchLocale(languages, locales, defaultLocale);
}

export function matchLocale(
  languages: readonly string[],
  locales: readonly string[],
  defaultLocale: string
) {
  try {
    return match(languages, locales, defaultLocale);
  } catch {
    return defaultLocale;
  }
}

export function handleLocaleParam(pathname: string, locales: string[]) {
  const localeParam = pathname.split("/").at(1);
  const isValid = locales.some((locale) => locale === localeParam);

  if (localeParam && isValid) {
    return localeParam;
  }

  return;
}

const VALID_LOCALES = [
  "de",
  "en",
  "fr",
  "it",
  "es",
  "pt",
  "sv",
  "ro",
  "zh",
  "cn",
  "cs",
  "hu",
];

export function setLocale({ locale, path }: { path: string; locale: string }) {
  const segs = path.split("/");

  const index = segs.findIndex((s) => VALID_LOCALES.includes(s));
  if (index >= 0) {
    segs.splice(index, 1);
  }
  const newPath = segs.join("/");

  return `/${locale}${newPath.startsWith("/") || newPath === "" ? "" : "/"}${newPath}`;
}
